import { Draft } from '@reduxjs/toolkit';

import { IProductData } from '../../index';

function editFailure(draft: Draft<IProductData>) {
  draft.edit.config.isLoading = false;
}

export default editFailure;
